import React, { useState } from "react";
import { FaPhoneAlt, FaWhatsapp, FaTimes, FaPlus } from "react-icons/fa";

function HidenIcon() {
  const [showButtons, setShowButtons] = useState(true);

  return (
    <>
      {/* ================= Floating Buttons ================= */}

      <div style={styles.container}>
        {showButtons && (
          <>
            {/* Call Button */}
            <a href="tel:+918371830744" style={{ ...styles.button, ...styles.call }}>
              <FaPhoneAlt />
            </a>

            {/* WhatsApp Button */}
            <a
              href="https://wa.me/918371830744"
              target="_blank"
              rel="noopener noreferrer"
              style={{ ...styles.button, ...styles.whatsapp }}
            >
              <FaWhatsapp />
            </a>
          </>
        )}

        {/* Open / Close Button */}
        <button
          onClick={() => setShowButtons(!showButtons)}
          style={{ ...styles.button, ...styles.close }}
        >
          {showButtons ? <FaTimes /> : <FaPlus />}
        </button>
      </div>

      {/* ================= Your Website Content ================= */}

     
    </>
  );
}

const styles = {
  container: {
    position: "fixed",
    right: "10px",
    top: "88%",
    transform: "translateY(-50%)",
    zIndex: 9999,
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },

  button: {
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: "20px",
    textDecoration: "none",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 8px 25px rgba(0,0,0,0.35)",
    transition: "0.3s",
  },

  call: {
    background: "#1f1f1f",
  },

  whatsapp: {
    background: "#25D366",
  },

  close: {
    background: "#80c762",
  },
};

export default HidenIcon;